import React, { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import {
  generateURLFromBrowser,
  getLocalStorage,
  isGmailAccountDomain,
  sendDataToSubDomain,
  setLocalStorage,
  wait,
} from '../helpers/jsHelper';
import {
  apiGetMemberOrganizationPermissions,
  apiGetOnlyOrganizationPermissions,
  apiGetOrganizationDetails,
  apiGetUserDetails,
} from '../helpers/api';
import { Loader } from '../common';
import { TEMPLATES_ROUTE_V2 } from '../constants/routePathConstants';
import {
  AUTH_TOKEN,
  CURRENT_USER,
  CURRENT_USER_ID,
  EMAIL_VERIFIED,
  IS_ACTIVE_ORG,
  IS_GAMIFIED_SKIP,
  IS_PACK_SUBSCRIPTION_USER,
  LATEST_TNC_ACCEPTED,
  REFRESH_TOKEN,
  VERIFICATION_TOKEN,
} from '../constants/projectConstants';
import { useNavigate } from 'react-router-dom';
import { errorToast } from '../helpers/toastHelper';
import { dispatcher } from '../helpers/projectHelper';
import { selectSignupPopOpenedFrom, setAssignEditorPopOpen, setChooseYourOrgPopOpen, setSignupPopOpen } from '../redux/slicers/uiSlicer';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { getAppState } from '../redux/store';
import {
  CURATOR_OPEN_SOURCE,
  UP_IS_EXPAND,
  IS_SHARED,
  UP_MODEL_ID,
  UP_MODEL_NAME,
  OPEN_IMAGES,
  UP_UPLOAD_EXTENSION,
  UP_UPLOAD_TYPE,
  UP_FILE_NAME,
  UP_HOTSPOT_NAME,
  UP_RENDER_ID,
  UP_MAIN_ORIGIN,
  USERPILOT_UUID,
} from '../constants/constants';
import { useDispatch } from 'react-redux';

export const loginDataAfterToken = async ({
  parsedData,
  userCtx,
  navigate,
  setLoading = null,
  redirectURL = null,
  triggerEvent = false,
  isGoogleSignup = false,
}) => {
  const { access, is_active_org, is_email_verified, refresh, id, is_guest = false } = parsedData;
  const isEmailVerified = is_guest || is_email_verified;
  if (access && refresh) {
    setLocalStorage(IS_ACTIVE_ORG, is_active_org);
    setLocalStorage(EMAIL_VERIFIED, isEmailVerified);
    setLocalStorage(LATEST_TNC_ACCEPTED, true);
    setLocalStorage(AUTH_TOKEN, access);
    setLocalStorage(REFRESH_TOKEN, refresh);
    setLocalStorage(IS_PACK_SUBSCRIPTION_USER, true);
    setLocalStorage(VERIFICATION_TOKEN, access);
    userCtx.setToken(access);
    userCtx.setRefreshToken(refresh);
    userCtx.setEmailVerified(isEmailVerified);
    userCtx.setLatestTNCAccepted(true);
    userCtx.setVerificationToken(access);
    await wait(500);
    const userdetails = await apiGetUserDetails();
    const orgResponse = await apiGetOrganizationDetails();

    localStorage.setItem(CURRENT_USER_ID, orgResponse?.owner || info?.id);
    userCtx.setCurrentId(orgResponse?.owner || info?.id);

    const organization_details = {
      ...(userdetails.organization_details || {}),
      id: orgResponse?.id,
      ...(orgResponse?.id
        ? {
            name: orgResponse.name,
            watermark_on_rendering: orgResponse.watermark_on_rendering,
          }
        : {}),
    };
    const info = {
      id: orgResponse?.owner,
      user: {
        id: userdetails.id,
        email: userdetails.email,
        name: `${userdetails.first_name} ${userdetails.last_name}`,
        first_name: userdetails.first_name,
        last_name: userdetails.last_name,
        profile_image: userdetails.profile_image,
        other_info: userdetails.other_info,
        is_guest: is_guest,
        member_id: orgResponse?.owner,
      },
      is_guest: is_guest,
      is_online: true,
      assigned_permissions: [],
      excluded_permissions: [],
      is_disable: false,
      is_active: true,
      organization: organization_details.id,
      organization_detail: organization_details,
      role: {
        id: userdetails.role_details?.id,
        name: userdetails.role_details?.name,
        is_admin: userdetails.role_details?.is_admin,
        is_external_member: userdetails.role_details?.is_external_member,
        is_internal_member: userdetails.role_details?.is_internal_member,
        is_owner: userdetails.role_details?.is_owner,
        is_staff: userdetails.role_details?.is_staff,
      },
      permissions_list: [],
      organization_permissions_list: [],
      is_editor: userdetails?.is_editor,
      is_live_on_app: userdetails?.is_live_on_app,
      is_editor_access: userdetails?.is_editor_access,
      is_active_org: is_active_org,
      is_basic_info: true,
    };
    console.log(userdetails, orgResponse, 'check all the data', info, parsedData);
    if (info) {
      info['is_editor'] = true;
      const permissions = await apiGetMemberOrganizationPermissions();
      const organizationPermissions = await apiGetOnlyOrganizationPermissions();
      if (permissions && permissions?.results?.length) {
        info['permissions_list'] = permissions?.results;
      }
      if (organizationPermissions && organizationPermissions?.results?.length) {
        info['organization_permissions_list'] = organizationPermissions?.results;
      }
      info.is_guest = is_guest;
      info.user.is_guest = is_guest;
      sendDataToSubDomain(window.location.pathname, info);
      userCtx.onLogin(info, access, refresh, isEmailVerified, true);
      // setLocalStorage(IS_GAMIFIED_SKIP, true);
      if (redirectURL) {
        if (triggerEvent) {
          Mixpanel.reset();
          Mixpanel.people.set({
            $first_name: userdetails.first_name,
            $last_name: userdetails.last_name,
            full_name: `${userdetails.first_name} ${userdetails.last_name}`,
            email: userdetails.email,
          });
          Mixpanel.track(false, MxEvent.SIGN_UP_SUCCESS, {
            event_origin_page: window?.location?.pathname,
            distinct_id: userdetails.email,
            email: userdetails.email,
            $first_name: userdetails.first_name,
            $last_name: userdetails.last_name,
            full_name: `${userdetails.first_name} ${userdetails.last_name}`,
            source: selectSignupPopOpenedFrom(getAppState()),
            is_google_signup: isGoogleSignup ? 'Yes' : 'No',
          });
        }
        // !isGmailAccountDomain(userdetails?.email) && dispatcher(setChooseYourOrgPopOpen(true));
        dispatcher(setAssignEditorPopOpen(true))
        navigate(redirectURL, { replace: true });
      } else {
        dispatcher(setSignupPopOpen(false));
      }
      setLoading && setLoading(false);
    } else {
      errorToast('You are no longer member of any organization. Please create your own.');
      // navigate(CREATE_ORGANIZATION_ROUTE);
    }
    sendDataToSubDomain(window.location.pathname, info);
    userCtx.onLogin(info, access, refresh, isEmailVerified, true);

    if (triggerEvent) {
      Mixpanel.reset();
      Mixpanel.people.set({
        $first_name: userdetails.first_name,
        $last_name: userdetails.last_name,
        full_name: `${userdetails.first_name} ${userdetails.last_name}`,
        email: userdetails.email,
      });
      Mixpanel.track(false, MxEvent.SIGN_UP_SUCCESS, {
        event_origin_page: window?.location?.pathname,
        distinct_id: userdetails.email,
        email: userdetails.email,
        $first_name: userdetails.first_name,
        $last_name: userdetails.last_name,
        full_name: `${userdetails.first_name} ${userdetails.last_name}`,
        source: selectSignupPopOpenedFrom(getAppState()),
        is_google_signup: isGoogleSignup ? 'Yes' : 'No',
      });
    }

    await wait(500);
    setLoading && setLoading(false);
  } else {
    console.log('Error in fetching tokens ');
    setLoading && setLoading(false);
  }
};

export default function GuestRegisterWithToken() {
  const userCtx = useUserContext();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const allData = params.get('allData');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log(allData, ' all data init');
    if (allData) {
      setLoading(true);
      console.log(JSON.parse(allData), ' check for all data');
      const parsedData = JSON.parse(allData);
      if (parsedData?.access) {
        const token = getLocalStorage(AUTH_TOKEN);
        let isLoggedIn = false;
        if (token && parsedData && token === parsedData?.access) {
          isLoggedIn = true;
        }
        const userpilotUUID = parsedData?.USERPILOT_UUID
        if (userpilotUUID) {
          setLocalStorage(USERPILOT_UUID, userpilotUUID);
        }

        const generatedUrl = generateURLFromBrowser();
        const redirectURL = generatedUrl || TEMPLATES_ROUTE_V2;
        const url = new URL(`${window.location.origin}${redirectURL}`);
        if (generatedUrl) {
          const parsedUrl = new URL(window.location.href);
          const openImages = parsedUrl.searchParams.get(OPEN_IMAGES);
          const curatorOpenSource = parsedUrl.searchParams.get(CURATOR_OPEN_SOURCE);
          const isShared = parsedUrl.searchParams.get(IS_SHARED);
          const params = url.searchParams;
          if (openImages) {
            params.append(OPEN_IMAGES, openImages);
          }
          if (curatorOpenSource) {
            params.append(CURATOR_OPEN_SOURCE, curatorOpenSource);
          }
          if (isShared) {
            params.append(IS_SHARED, isShared);
          }

          // other data to send on userpilot
          const renderId = parsedUrl.searchParams.get(UP_RENDER_ID);
          const isExpand = parsedUrl.searchParams.get(UP_IS_EXPAND);
          const modelId = parsedUrl.searchParams.get(UP_MODEL_ID);
          const modelName = parsedUrl.searchParams.get(UP_MODEL_NAME);
          const uploadType = parsedUrl.searchParams.get(UP_UPLOAD_TYPE);
          const uploadExtension = parsedUrl.searchParams.get(UP_UPLOAD_EXTENSION);
          const fileName = parsedUrl.searchParams.get(UP_FILE_NAME);
          const hostspotName = parsedUrl.searchParams.get(UP_HOTSPOT_NAME);
          const mainOrigin = parsedUrl.searchParams.get(UP_MAIN_ORIGIN);
          
          if (renderId) {
            params.append(UP_RENDER_ID, renderId);
          }
          if (isExpand) {
            params.append(UP_IS_EXPAND, isExpand);
          }
          if (modelId) {
            params.append(UP_MODEL_ID, modelId);
          }
          if (modelName) {
            params.append(UP_MODEL_NAME, modelName);
          }
          if (uploadType) {
            params.append(UP_UPLOAD_TYPE, uploadType);
          }
          if (uploadExtension) {
            params.append(UP_UPLOAD_EXTENSION, uploadExtension);
          }
          if (fileName) {
            params.append(UP_FILE_NAME, fileName);
          }
          if (hostspotName) {
            params.append(UP_HOTSPOT_NAME, hostspotName);
          }
          if (mainOrigin) {
            setLocalStorage(UP_MAIN_ORIGIN, mainOrigin);
            params.append(UP_MAIN_ORIGIN, mainOrigin);
          }        
        }
        let constructedUrl = `${url.pathname}`;
        if (url?.search) {
          constructedUrl = `${constructedUrl}${url?.search}`;
        }
        const urlToPass = constructedUrl;
        // user is logged so no need to login again
        if (isLoggedIn) {
          // const currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
          // !isGmailAccountDomain(currentUser?.user?.email) && dispatch(setChooseYourOrgPopOpen(true));
          navigate(urlToPass, { replace: true });
        } else {
          loginDataAfterToken({
            parsedData,
            userCtx,
            navigate,
            setLoading,
            redirectURL: urlToPass,
          });
        }
      } else {
        console.log('Did not get access. Did not get access.');
      }
    }
  }, [allData]);

  return (
    <>
      <Loader loading={loading} position="fixed" />
    </>
  );
}